import { Box, Icon, Spacer, Text } from '@dtx-company/shared-components/src'
import React from 'react'

export const FlowpageViewOnlyPermissionCard: React.FC = () => {
  return (
    <Box
      bg="#F1F5FE"
      width="100%"
      p="16px 12px"
      flexDirection={'column'}
      maxWidth={{
        _: 'none',
        lg: '500px'
      }}
    >
      <Box bg="#FEF2D5" p="8px" borderRadius={'16px'} alignItems="center" width="max-content">
        <Icon src="/icons/eye.svg" pr="8px" height={'24px'} alt="" />
        <Text>View Only</Text>
      </Box>
      <Spacer mt="12px" />
      <Text>Reach out to the creator for edit access.</Text>
    </Box>
  )
}
